import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild,OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ButtonType } from '@ascschool/interface/setting';
import { Province } from '@ascschool/model/category/province.model';
import { CommonFilter } from '@ascschool/model/commonfilter/commonfilter';
import { AuthQuery } from '@ascschool/core/auth/auth.query';
import { AuthService } from '@ascschool/core/auth/auth.service';
import { SizePageService } from '@ascschool/project/size-page/size-page.service';
import { ProvinceService } from '@ascschool/services/category/province.service';
import { UtilsService } from '@ascschool/services/utils.service';
import { ShortcutInput } from 'ng-keyboard-shortcuts';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { Observable,Subject } from 'rxjs';
import { map,takeUntil } from 'rxjs/operators';
import { BaocaoService } from '@ascschool/services/baocao/baocao.service';
import { DistrictService } from '@ascschool/services/category/district.service';
import { TypeOfDisabilityService } from '@ascschool/services/category/typeofdisability.service';
import { LevelService } from '@ascschool/services/category/level.service';
import { EducationalStatusService } from '@ascschool/services/category/educational-status.service';
import { StudyModeService } from '@ascschool/services/category/study-mode.service';
import { NeedForEducationalSpService } from '@ascschool/services/survey/need-for-educational-sp.service';
import { SchoolService } from '@ascschool/services/organization/school.service';
import { FolkService } from '@ascschool/services/school/folk.service';
import { TypeOfPersonnelService } from '@ascschool/services/category/type-of-personnel.service';
import { EmploymentStatusService } from '@ascschool/services/school/employment-status.service';
import { QualificationService } from '@ascschool/services/category/qualification.service';
import { MajorService } from '@ascschool/services/category/major.service';
import { PersonnelStatusService } from '@ascschool/services/category/personnel-status.service';
import { ModesOfEducationService } from '@ascschool/services/category/modese-of-education.service';
@Component({
  selector: 'app-ns-bcttnnl',
  templateUrl: './ns-bcttnnl.component.html',
  styleUrls: ['./ns-bcttnnl.component.scss']
})
export class BcTtNnlComponent implements OnInit, AfterViewInit,OnDestroy {
  isResizdePopup: boolean;
  dialogRef: NzModalRef;
  @ViewChild('tplTitle', { static: false }) titlePopupElement;
  constructor(
    private msg: NzMessageService, private cdRef: ChangeDetectorRef, public _authService: AuthService,
    public sizePageService: SizePageService, private authQuery: AuthQuery,
    private service: BaocaoService, public utilService: UtilsService, private disProvincesService: ProvinceService,
    private districtService: DistrictService, private schoolService: SchoolService,
    private folkService: FolkService, private typeOfPersonnelService: TypeOfPersonnelService,
    private mojorServiceService: MajorService, private employmentStatusService: PersonnelStatusService,
    private qualificationService: QualificationService, private modesOfEducationService: ModesOfEducationService
  ) {
    this.currentUser = JSON.parse(localStorage.getItem('userSetting'));
  }
  get breadcrumbs(): string[] {
    return ['Báo cáo về nhân sự'];
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  @ViewChild('pageHeaderTable', { static: false }) set content(content: ElementRef) {
    if (content) {
      // initially setter gets called with undefined
      this.elementPageHeaderTable = content;
    }
  }
  @ViewChild('pageHeaderTable2', { static: false }) set content2(content2: ElementRef) {
    if (content2) {
      // initially setter gets called with undefined
      this.elementPageHeaderTable2 = content2;
    }
  }
  // pageOptBtn: BtnOptionExtend[] = [new BtnOptionExtend('Thêm', 'plus', this.AddProvince.bind(this), null, null, Nztheme.OUTLINE, 'text-green-600')]
  $unSubcsribe = new Subject();
  buttonTypeEnum = ButtonType;
  btnType: ButtonType;
  shortcuts: ShortcutInput[] = [];
  commonFilter = new CommonFilter();
  searchTerm = '';
  pageIndex = 1;
  province = new Province();
  pageSizeOptions: number[] = [50, 100, 200];
  pageSize: number = this.pageSizeOptions[0];
  loading = true;
  Total = 0;
  firstRowOnPage: any;
  dataTable: any;
  width: number;
  numberControl: number;
  private elementPageHeaderTable: ElementRef;
  private elementPageHeaderTable2: ElementRef;
  @ViewChild('pageOptionBtnGroup', { static: false }) elementpageOptionBtnGroup: ElementRef;
  @ViewChild('pageSearch', { static: false }) elementPageSearch: ElementRef;
  show = false;
  maxHeight: number;
  height: number;
  heightPopup: number;
  heightPagnagation = 50;
  isCollapse = true;
  year = '';
  currentUser: any;
  isDisabled : boolean = false;
  isDisabled1 : boolean = false;
  isDisabled2 : boolean = false;
  getProvinceACFn: (value: any) => Observable<any>; ProvinceSubscription: any; ProvinceControl = new FormControl();
  getDisProvincesACFn: (value: any) => Observable<any>; DisProvincesSubscription: any; DisProvincesControl = new FormControl();
  getDistrictACFn: (value: any) => Observable<any>; DistrictSubscription: any; DistrictControl = new FormControl();

  getEducationSCHooLACFn: (value: any) => Observable<any>; EducationSCHoolSubscription: any; EducationSCHoolControl = new FormControl();
  getFolkACFn: (value: any) => Observable<any>; FolkSubscription: any; FolkControl = new FormControl();
  getModesOfEducationACFn: (value: any) => Observable<any>; ModesOfEducationSubscription: any; ModesOfEducationControl = new FormControl();
  getTypeOfPersonnalACFn: (value: any) => Observable<any>; TypeOfPersonnalSubscription: any; TypeOfPersonnalControl = new FormControl();
  getEmploymentStatus: (value: any) => Observable<any>; EmploymentStatusSubscription: any; EmploymentStatusControl = new FormControl();

  getQualification: (value: any) => Observable<any>; QualificationSubscription: any; QualificationControl = new FormControl();
  getMajorACFn: (value: any) => Observable<any>; MajorSubscription: any; MajorControl = new FormControl();

  sortNameFn = (a: Province, b: Province) => a.provinceName.localeCompare(b.provinceName);
  ngOnInit() {
    if(this.currentUser.accountType === 3){
      this.isDisabled = true;
    }else if(this.currentUser.accountType === 1){
      this.isDisabled1 = true;
    }else if(this.currentUser.accountType === 2){
      this.isDisabled2 = true;
    }
    if (this.currentUser.accountType === 3) {
      this.commonFilter.ProvinceId = this.currentUser.provinceId;
    }
    if (this.currentUser.accountType === 3) {
      this.disProvincesService.getSelectPagingProvinceById(this.currentUser.provinceId).subscribe(res => {
        this.DisProvincesControl.setValue({ id: res.id, text: res.provinceName });
        //School
        this.getEducationSCHooLACFn = (value: any) => this.schoolService.getSelectPagingForStaff({
          searchTerm: value, ProvinceId: this.currentUser.provinceId, SubordinateTypeId: 0, PageIndex: 1, PageSize: 100
        }).pipe(map(resp => resp.results.length > 0
          ? resp.results.map(x => ({ id: x.id, text: x.educationAndTrainingName })) : [{ id: null, text: 'Không có dữ liệu' }]));
        if (!this.EducationSCHoolSubscription) {
          this.EducationSCHoolSubscription = this.EducationSCHoolControl.valueChanges.subscribe(() => {
            this.utilService.bindOrUnBindTheId(this.commonFilter, 'SchoolId', this.EducationSCHoolControl.value);
          });
        }
        //Quận huyện
        this.getDistrictACFn = (value: any) => this.districtService.getDistrictSelectPaging({
          searchTerm: value, ProvinceId: this.currentUser.provinceId, PageIndex: 1, PageSize: 100
        }).pipe(map(resp => resp.results.length > 0
          ? resp.results.map(x => ({ id: x.id, text: x.districtName })) : [{ id: null, text: 'Không có dữ liệu' }]));
        if (!this.DistrictSubscription) {
          this.DistrictSubscription = this.DistrictControl.valueChanges.subscribe(() => {
            this.utilService.bindOrUnBindTheId(this.commonFilter, 'DistrictId', this.DistrictControl.value);
          });
        }
      });
      //get school
      this.schoolService.GetSelectPagingById(this.currentUser.eadId).subscribe(response => {
        this.EducationSCHoolControl.setValue({
          ProvinceId: this.currentUser.provinceId, id: response.id, text: response.educationAndTrainingName
        })
      });
      //get quận huyện
      this.districtService.getSelectPagingDistrictById(this.currentUser.districtId).subscribe(response => {
        this.DistrictControl.setValue({ ProvinceId: this.currentUser.provinceId, id: response.id, text: response.districtName });
      });
    }
    if (this.currentUser.accountType === 1) {
      this.disProvincesService.getSelectPagingProvinceById(this.currentUser.provinceId).subscribe(res => {
        this.DisProvincesControl.setValue({ id: res.id, text: res.provinceName });

        this.getDistrictACFn = (value: any) => this.districtService.getDistrictSelectPaging({
          searchTerm: value, ProvinceId: this.currentUser.provinceId, PageIndex: 1, PageSize: 100
        }).pipe(map(resp => resp.results.length > 0
          ? resp.results.map(x => ({ id: x.id, text: x.districtName })) : [{ id: null, text: 'Không có dữ liệu' }]));
        if (!this.DistrictSubscription) {
          this.DistrictSubscription = this.DistrictControl.valueChanges.subscribe(() => {
            this.utilService.bindOrUnBindTheId(this.commonFilter, 'DistrictId', this.DistrictControl.value);
          });

          this.getEducationSCHooLACFn = (value: any) => this.schoolService.getSelectPagingForStaff({
            searchTerm: value, ProvinceId: this.currentUser.provinceId, SubordinateTypeId: 0, PageIndex: 1, PageSize: 100
          }).pipe(map(resp => resp.results.length > 0
            ? resp.results.map(x => ({ id: x.id, text: x.educationAndTrainingName })) : [{ id: null, text: 'Không có dữ liệu' }]));
          if (!this.EducationSCHoolSubscription) {
            this.EducationSCHoolSubscription = this.EducationSCHoolControl.valueChanges.subscribe(() => {
              this.utilService.bindOrUnBindTheId(this.commonFilter, 'SchoolId', this.EducationSCHoolControl.value);
            });
          }
        }
      });
    }
    if (this.currentUser.accountType === 1) {
      this.commonFilter.subordinateTypeId = this.currentUser.eadId;
    } else {
      this.commonFilter.subordinateTypeId = 0;
    }
    if (this.currentUser.accountType === 2) {
      this.disProvincesService.getSelectPagingProvinceById(this.currentUser.provinceId).subscribe(res => {
        this.DisProvincesControl.setValue({ id: res.id, text: res.provinceName });
        this.getDistrictACFn = (value: any) => this.districtService.getDistrictSelectPaging({
          searchTerm: value, ProvinceId: this.currentUser.provinceId, PageIndex: 1, PageSize: 100
        }).pipe(map(resp => resp.results.length > 0
          ? resp.results.map(x => ({ id: x.id, text: x.districtName })) : [{ id: null, text: 'Không có dữ liệu' }]));
        if (!this.DistrictSubscription) {
          this.DistrictSubscription = this.DistrictControl.valueChanges.subscribe(() => {
            this.utilService.bindOrUnBindTheId(this.commonFilter, 'DistrictId', this.DistrictControl.value);
          });
        }
        this.districtService.getSelectPagingDistrictById(this.currentUser.districtId).subscribe(response => {
          this.DistrictControl.setValue({ id: response.id, text: this.currentUser.eadName });
          this.reload();
        });
      });

      this.getEducationSCHooLACFn = (value: any) => this.schoolService.getSelectPagingForStaff({
        searchTerm: value, ProvinceId: this.currentUser.provinceId, SubordinateTypeId: 0, PageIndex: 1, PageSize: 100
      }).pipe(map(resp => resp.results.length > 0
        ? resp.results.map(x => ({ id: x.id, text: x.educationAndTrainingName })) : [{ id: null, text: 'Không có dữ liệu' }]));
      if (!this.EducationSCHoolSubscription) {
        this.EducationSCHoolSubscription = this.EducationSCHoolControl.valueChanges.subscribe(() => {
          this.utilService.bindOrUnBindTheId(this.commonFilter, 'SchoolId', this.EducationSCHoolControl.value);
        });
      }
    }
    this.commonFilter.PageIndex = 1;
    this.commonFilter.PageSize = this.pageSizeOptions[0];
    this.reload();
    this.maxHeight = window.innerHeight;
    this.authQuery.userSetting$.subscribe((type) => {
      if (type) {
        this.btnType = type.btnType;
      }
    });
    this.checkCaculateHeight();
    this.commonFilter.year = this.year;
    this.loadDisProvinces();
    this.loadDistrict();
    this.loadFolk();
    this.loadModesOfEducation();
    this.loadTypeOfPersonnel();
    this.loadEmploymentStatus();
    this.loadQualification();
    this.loadMajor();
    this.commonFilter.year = this.year;
  }
  changeYear() {
    this.commonFilter.year = this.year;
  }
  reload() {
    const _this = this;
    this.loading = true;
    _this.dataTable = [];
    this.commonFilter.year = this.year;
    this.service.getRpttnnl(this.commonFilter).pipe(takeUntil(this.$unSubcsribe)).subscribe((response: any) => {
      const list = response.results ? response.results : [];
      this.Total = response && response.rowCount ? response.rowCount : 0;
      this.firstRowOnPage = response && response.firstRowOnPage ? response.firstRowOnPage : 0;
      _this.dataTable = list ? list : [];
      _this.loading = false;
    }, (err: any) => {
      _this.dataTable = [];
      _this.loading = false;
    });
  }

  search() {
    this.commonFilter.PageIndex = 1;
    this.reload();
  }

  exportExcel() {
    this.commonFilter.year = this.year;
    this.service.exportRprrnnl(this.commonFilter).subscribe((data : any) => {
      const downloadURL = window.URL.createObjectURL(data);
      const link = document.createElement('a');
      link.href = downloadURL;
      link.download = 'BaoCaoThongTinNguonNhanLuc.xlsx';
      link.click();
    });
  }
  pageIndexEvent(pageE: any) {
    this.commonFilter.PageIndex = pageE;
    this.pageIndex = pageE;
    this.reload();
  }

  pageSizeEvent(pageE: any) {
    this.commonFilter.PageSize = pageE;
    this.pageSize = pageE;
    this.reload();
  }

  ngAfterViewInit() {
    this.checkCaculateHeight(this.isCollapse);
    // keyboard
    this.shortcuts.push({
      key: ['alt + n'], label: 'Help', description: 'Cmd + b', command: (e) => console.log('alt + n'), preventDefault: true
    });
    this.cdRef.detectChanges();
  }

  isDivisibleForFour(index: number) {
    if (index % 4 === 0) {
      return true;
    } else {
      return false;
    }
  }

  checkCaculateHeight(isOpen?: boolean) {
    setTimeout(() => {
      this.height = this.heightfnc();
      this.width = 3000;
    }, 1);
  }

  heightfnc() {
    return this.sizePageService.caculateHeight(
      this.elementpageOptionBtnGroup,
      this.elementPageSearch,
      this.elementPageHeaderTable,
      this.elementPageHeaderTable2,
      this.heightPagnagation
    );
  }

  widthfnc() {
    return this.sizePageService.caculateWidth(this.elementPageSearch);
  }

  onResize() {
    this.width = 3000;
    this.checkCaculateHeight(this.isCollapse);
  }

  toggleCollapse(): void {
    this.maxHeight = window.innerHeight;
    this.isCollapse = !this.isCollapse;
    this.checkCaculateHeight(this.isCollapse);
  }

  resetForm(): void { }
  // tslint:disable-next-line: adjacent-overload-signatures
  loadDisProvinces() {
    // tslint:disable-next-line: max-line-length
    this.getDisProvincesACFn = (value: any) => this.disProvincesService.getProvinceSelectPaging({
      searchTerm: value, PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.provinceName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    // tslint:disable-next-line: max-line-length
    if (!this.DisProvincesSubscription) {
      this.DisProvincesSubscription = this.DisProvincesControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'ProvinceId', this.DisProvincesControl.value);
      });
    }
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  changeDisProvincesACFn(control: FormControl) {
    if (control.value) {
      this.DisProvincesControl = control;
      if (this.currentUser.accountType === 5 || this.currentUser.accountType === 6) {
        this.loadSchool(control.value.id,0);
        this.loadDistrict();
      }
      if (this.currentUser.accountType === 1) {
        this.commonFilter.subordinateTypeId = this.currentUser.eadId;
        this.loadSchool(control.value.id,0);
        this.loadDistrict();
      }
    } else {
      this.EducationSCHoolControl.setValue(null);
    }
  }
  loadDistrict() {
    // tslint:disable-next-line: max-line-length
    this.getDistrictACFn = (value: any) => this.districtService.getDistrictSelectPaging({
      searchTerm: value, ProvinceId: this.valueIfHas(this.DisProvincesControl), PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.districtName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    // tslint:disable-next-line: max-line-length
    if (!this.DistrictSubscription) {
      this.DistrictSubscription = this.DistrictControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'DistrictId', this.DistrictControl.value);
      });
    }
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  changeDistrictACFn(control: FormControl) {
    this.DistrictControl = control;
    if(this.currentUser.accountType === 2){
      this.commonFilter.subordinateTypeId = this.currentUser.eadId;
      this.loadSchool(this.DisProvincesControl.value.id,this.DistrictControl.value.id)
    }else{
      this.loadSchool(this.DisProvincesControl.value.id,this.DistrictControl.value.id)
    }
  }


  loadSchool(idProvince: number, idDistrict : number) {
    this.getEducationSCHooLACFn = (value: any) => this.schoolService.getSelectPagingForStaff({
      searchTerm: value, ProvinceId: idProvince, SubordinateTypeId: this.commonFilter.subordinateTypeId,DistrictId: idDistrict, PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.educationAndTrainingName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    if (!this.EducationSCHoolSubscription) {
      this.EducationSCHoolSubscription = this.EducationSCHoolControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'SchoolId', this.EducationSCHoolControl.value);
      });
    }
  }
  changeEducationSchool(control: FormControl) {
    this.EducationSCHoolControl = control;
  }

  loadFolk() {
    this.getFolkACFn = (value: any) => this.folkService.getFolkSelectPaging({
      searchTerm: value, PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.folkName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    if (!this.FolkSubscription) {
      this.FolkSubscription = this.FolkControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'FolkId', this.FolkControl.value);
      });
    }
  }
  changeFolk(control: FormControl) {
    this.FolkControl = control;
  }

  loadModesOfEducation() {
    this.getModesOfEducationACFn = (value: any) => this.modesOfEducationService.getSelectPaging({
      searchTerm: value, PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }]));
    if (!this.ModesOfEducationSubscription) {
      this.ModesOfEducationSubscription = this.ModesOfEducationControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'ModesOfEducationId', this.ModesOfEducationControl.value);
      });
    }
  }
  changeModesOfEducation(control: FormControl) {
    this.ModesOfEducationControl = control;
  }

  loadTypeOfPersonnel() {
    // tslint:disable-next-line: max-line-length
    this.getTypeOfPersonnalACFn = (value: any) => this.typeOfPersonnelService.getTypeOfPersonnelSelectPaging({
      searchTerm: value, PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.typeOfPersonnelName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    if (!this.TypeOfPersonnalSubscription) {
      this.TypeOfPersonnalSubscription = this.TypeOfPersonnalControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'TypeOfPersonnelId', this.TypeOfPersonnalControl.value);
      });
    }
  }
  changeTypeOfPersonnel(control: FormControl) {
    this.TypeOfPersonnalControl = control;
  }

  loadEmploymentStatus() {
    // tslint:disable-next-line: max-line-length
    this.getEmploymentStatus = (value: any) => this.employmentStatusService.getPersonnelStatusSelectPaging({
      searchTerm: value, PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.statusName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    if (!this.EmploymentStatusSubscription) {
      this.EmploymentStatusSubscription = this.EmploymentStatusControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'EmploymentStatusId', this.EmploymentStatusControl.value);
      });
    }
  }
  changeEmploymentStatus(control: FormControl) {
    this.EmploymentStatusControl = control;
  }

  loadQualification() {
    // tslint:disable-next-line: max-line-length
    this.getQualification = (value: any) => this.qualificationService.getSelectPaging({
      searchTerm: value, PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.qualificationName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    if (!this.QualificationSubscription) {
      this.QualificationSubscription = this.QualificationControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'QualificationId', this.QualificationControl.value);
      });
    }
  }
  changeQualification(control: FormControl) {
    this.QualificationControl = control;
  }

  loadMajor() {
    // tslint:disable-next-line: max-line-length
    this.getMajorACFn = (value: any) =>
      this.mojorServiceService.getSelectPaging({
        searchTerm: value, PageIndex: 1, PageSize: 100
      }).pipe(map((resp) =>
        resp.results.length > 0
          ? resp.results.map((x) => ({ id: x.id, text: x.majorName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    if (!this.MajorSubscription) {
      this.MajorSubscription = this.MajorControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'MajorId', this.MajorControl.value);
      });
    }
  }

  // tslint:disable-next-line: adjacent-overload-signatures
  changeMajor(control: FormControl) {
    this.MajorControl = control;
  }
  clear() {
    this.year = '';
    if(this.currentUser.accountType === 6 || this.currentUser.accountType === 5){
      this.DisProvincesControl.setValue(null);
    } if(this.currentUser.accountType === 6 || this.currentUser.accountType === 5 || this.currentUser.accountType === 1){
      this.DistrictControl.setValue(null);
      this.EducationSCHoolControl.setValue(null);
    } if(this.currentUser.accountType !== 3){
      this.EducationSCHoolControl.setValue(null);
    }
    this.FolkControl.setValue(null);
    this.TypeOfPersonnalControl.setValue(null);
    this.EmploymentStatusControl.setValue(null);
    this.QualificationControl.setValue(null);
    this.MajorControl.setValue(null);
    this.commonFilter.StaffCode = "";
    this.commonFilter.FullName = "";
    delete this.commonFilter.Gender;
    delete this.commonFilter.StaffUnfostered;
    delete this.commonFilter.YearOfBirth;
    delete this.commonFilter.YearsOfService;
    delete this.commonFilter.YearsOfTeaching;
    this.reload();
  }

  valueIfHas(control: FormControl) {
    if (control.value && typeof control.value !== 'string') { return control.value.id; }
    return '';
  }
  ngOnDestroy(): void {
    this.$unSubcsribe.next();
    this.$unSubcsribe.complete();
}
}
